import type { LinkProps } from '@ps/web-shared-components';
import { Link } from '@ps/web-shared-components';
import { type IspSportsAlias, isIspSportsAlias } from '@ps/web-sports-config';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';

const reRouteRules: Partial<Record<EventTypeId, Record<IspSportsAlias, IspSportsAlias>>> = {
  [EventTypeId.GOLF]: {
    sportsCompetition: 'sportsCompetitionOutrights'
  } as Record<IspSportsAlias, IspSportsAlias>
};

/**
 * Changes the link of specific event types from one routing key to another
 * Useful for pages that have different defaults landing pages
 */
export const SportsLink: React.FC<LinkProps> = ({ alias, ...restProps }) => {
  const { values } = restProps;
  let actualAlias = alias;

  if (alias && restProps.values?.eventTypeId && isIspSportsAlias(alias)) {
    const { eventTypeId } = restProps.values;
    const newRoute = reRouteRules[eventTypeId as EventTypeId]?.[alias];

    if (newRoute) actualAlias = newRoute;
  }

  const formattedMarketId =
    values?.marketId && typeof values.marketId === 'string'
      ? values.marketId.replace('.', '-')
      : undefined;

  return (
    <Link
      {...restProps}
      values={{ ...values, ...(formattedMarketId && { marketId: formattedMarketId }) }}
      alias={actualAlias}
    />
  );
};
